function pad(value) {
  return String(value).padStart(2, '0')
}

/** A stored ISO deadline as the date picker's local YYYY-MM-DD (null when unset or invalid). */
export function deadlineDate(value) {
  if (typeof value !== 'string' || !value) return null
  const date = new Date(value)
  if (Number.isNaN(date.getTime())) return null
  return `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())}`
}

/**
 * The picked day as an ISO deadline with the local offset (what validCountdownDeadline
 * accepts), keeping the time of the previous value — 23:59 for a new deadline.
 */
export function deadlineIso(day, previous) {
  if (!day) return null
  const old = previous ? new Date(previous) : null
  const time = old && !Number.isNaN(old.getTime())
    ? `${pad(old.getHours())}:${pad(old.getMinutes())}:00`
    : '23:59:00'
  const local = new Date(`${day}T${time}`)
  const offset = -local.getTimezoneOffset()
  const sign = offset >= 0 ? '+' : '-'
  const absolute = Math.abs(offset)
  return `${day}T${time}${sign}${pad(Math.floor(absolute / 60))}:${pad(absolute % 60)}`
}
